import styled, { createGlobalStyle, css, keyframes, ThemeProvider } from 'styled-components';

import { Theme } from './Theme';
import { Breakpoints } from './Theme.types';

const getBreakpoint = (breakpoint: Breakpoints) => Theme.variables.breakpoints[breakpoint];

export const from = (breakpoint: Breakpoints) => () => `@media (min-width: ${getBreakpoint(breakpoint)}px)`;
export const to = (breakpoint: Breakpoints) => () => `@media (max-width: ${getBreakpoint(breakpoint) - 1}px)`;

export { css, createGlobalStyle, keyframes, ThemeProvider };
export { Theme };

export default styled;
